import {
  AppBar,
  createStyles,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { colors } from 'design-system';
import { XCircle } from 'react-feather';
// functions
import { getOptionName } from 'src/functions/individualOptionHelpers';
import OptionSummary from './OptionSumary';

type Props = {
  open: boolean;
  onCloseRequested: () => void;
  optionSelected: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentWrappingDialog: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
    },
    dialoguePaperStyle: {
      background: '#f9f9f9',
    },
    appDialogBar: {
      backgroundColor: colors.white,
    },
    appDialogBarOffset: theme.mixins.toolbar,
    closeIcon: {
      top: theme.spacing(2),
      right: theme.spacing(2),
      position: 'absolute',
    },
    px: {
      color: colors.bright_turquoise,
    },
  }),
);

const SumaryDialogue = ({
  open,
  onCloseRequested,
  optionSelected,
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Dialog
      data-testid="summary-details-dialog"
      open={open}
      fullScreen
      PaperProps={{
        className: classes.dialoguePaperStyle,
      }}
    >
      <AppBar position="fixed" className={classes.appDialogBar} elevation={0}>
        <Toolbar>
          <Grid container justifyContent="center">
            <Typography variant="body1" data-testid="details-title">
              Auto<span className={classes.px}>PX</span>{' '}
              {getOptionName(optionSelected)}
            </Typography>
          </Grid>
        </Toolbar>
        <IconButton
          data-testid="close-button"
          className={classes.closeIcon}
          onClick={onCloseRequested}
        >
          <XCircle color={colors.madison} />
        </IconButton>
      </AppBar>

      <div className={classes.appDialogBarOffset} />
      <div className={classes.contentWrappingDialog}>
        <Grid container spacing={2}>
          <OptionSummary
            data-testid="policy-summary-details"
            optionSelected={optionSelected}
            openDialog={open}
          />
        </Grid>
      </div>
    </Dialog>
  );
};

export default SumaryDialogue;
